import React, { useId } from 'react'

type AnimatedSpinnerProps = {
  ariaLabel: string
  dataTestId: string
}

export const ProgressCircularDarkSuccess: React.FC<AnimatedSpinnerProps> = ({ ariaLabel, dataTestId }) => {
  const uniqueId = useId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel}
      data-testid={dataTestId}
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      style={{ width: '100%', height: '100%' }}
    >
      <defs>
        <animate
          repeatCount="indefinite"
          dur="2.3833333s"
          begin="0s"
          xlinkHref={`#_R_G_L_2_G_${uniqueId}`}
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="1"
          keyTimes="0;0.020979;0.041958;1"
          values="0;0;1;1"
          keySplines="0.167 0.167 0.667 1;0.167 0.167 0.667 1;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="2.3833333s"
          begin="0s"
          xlinkHref={`#_R_G_L_2_G_M_${uniqueId}`}
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="1"
          keyTimes="0;0.020979;0.0209797;1"
          values="0;0;1;1"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="2.3833333s"
          begin="0s"
          xlinkHref={`#_R_G_L_1_G_${uniqueId}`}
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.041958;0.1328671;1"
          values="0;0.6;0;0"
          keySplines="0.333 0 0.667 1;0.167 0 0.4 1;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="2.3833333s"
          begin="0s"
          xlinkHref={`#_R_G_L_0_G_D_0_P_0_${uniqueId}`}
          fill="freeze"
          attributeName="d"
          attributeType="XML"
          from="M-12.87 -0.75 C-12.87,-0.75 -12.75,-0.75 -12.75,-0.75 C-12.75,-0.75 -12.87,-0.75 -12.87,-0.75 "
          to="M-12.87 -0.75 C-12.87,-0.75 -5.25,8.63 -5.25,8.63 C-5.25,8.63 11.25,-9.25 11.25,-9.25 "
          keyTimes="0;0.006993;0.048951;0.0979021;0.1328671;1"
          values="M-12.87 -0.75 C-12.87,-0.75 -12.75,-0.75 -12.75,-0.75 C-12.75,-0.75 -12.87,-0.75 -12.87,-0.75 ;M-12.87 -0.75 C-12.87,-0.75 -12.75,-0.75 -12.75,-0.75 C-12.75,-0.75 -12.87,-0.75 -12.87,-0.75 ;M-12.62 -0.56 C-12.62,-0.56 -5.12,8.53 -5.12,8.53 C-5.12,8.53 -5.25,8.53 -5.25,8.53 ;M-12.87 -0.75 C-12.87,-0.75 -5.25,8.63 -5.25,8.63 C-5.25,8.63 11.25,-9.25 11.25,-9.25 ;M-12.87 -0.75 C-12.87,-0.75 -5.25,8.63 -5.25,8.63 C-5.25,8.63 11.25,-9.25 11.25,-9.25 ;M-12.87 -0.75 C-12.87,-0.75 -5.25,8.63 -5.25,8.63 C-5.25,8.63 11.25,-9.25 11.25,-9.25 "
          keySplines="0.167 0.167 0.667 1;0.167 0.167 0.667 1;0.333 0 0.667 1;0.333 0 0.667 1;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="2.3833333s"
          begin="0s"
          xlinkHref={`#_R_G_L_0_G_M_${uniqueId}`}
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="1"
          keyTimes="0;0.006993;0.0069937;1"
          values="0;0;1;1"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          attributeType="XML"
          attributeName="opacity"
          dur="2s"
          from="0"
          to="1"
          xlinkHref={`#time_group_${uniqueId}`}
        />
      </defs>
      <g id={`_R_G_${uniqueId}`}>
        <g id={`_R_G_L_2_G_M_${uniqueId}`}>
          <g
            id={`_R_G_L_2_G_${uniqueId}`}
            transform=" translate(32.968, 31.372) rotate(-257.527) scale(0.99977, 0.99977) translate(291.5, -129)"
          >
            <path
              id={`_R_G_L_2_G_D_0_P_0_${uniqueId}`}
              fill="#00bd46"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M-293.05 105.31 C-279.52,104 -267.49,113.91 -266.18,127.44 C-264.87,140.97 -274.78,153 -288.31,154.31 C-301.84,155.61 -313.87,145.71 -315.17,132.18 C-316.48,118.65 -306.57,106.62 -293.05,105.31z "
            />
            <path
              id={`_R_G_L_2_G_D_1_P_0_${uniqueId}`}
              stroke="#00bd46"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              strokeWidth="5"
              strokeOpacity="1"
              d=" M-293.05 105.31 C-279.52,104 -267.49,113.91 -266.18,127.44 C-264.87,140.97 -274.78,153 -288.31,154.31 C-301.84,155.61 -313.87,145.71 -315.17,132.18 C-316.48,118.65 -306.57,106.62 -293.05,105.31z "
            />
          </g>
        </g>
        <g
          id={`_R_G_L_1_G_${uniqueId}`}
          transform=" translate(32.968, 31.372) rotate(-257.527) scale(0.99977, 0.99977) translate(291.5, -129)"
        >
          <path
            id={`_R_G_L_1_G_D_0_P_0_${uniqueId}`}
            fill="#595959"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M-293.05 105.31 C-279.52,104 -267.49,113.91 -266.18,127.44 C-264.87,140.97 -274.78,153 -288.31,154.31 C-301.84,155.61 -313.87,145.71 -315.17,132.18 C-316.48,118.65 -306.57,106.62 -293.05,105.31z "
          />
          <path
            id={`_R_G_L_1_G_D_1_P_0_${uniqueId}`}
            stroke="#595959"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            strokeWidth="5"
            strokeOpacity="1"
            d=" M-293.05 105.31 C-279.52,104 -267.49,113.91 -266.18,127.44 C-264.87,140.97 -274.78,153 -288.31,154.31 C-301.84,155.61 -313.87,145.71 -315.17,132.18 C-316.48,118.65 -306.57,106.62 -293.05,105.31z "
          />
        </g>
        <g id={`_R_G_L_0_G_M_${uniqueId}`}>
          <g id={`_R_G_L_0_G_${uniqueId}`} transform=" translate(32.3, 32) scale(0.99982, 0.99982) translate(0, 0)">
            <path
              id={`_R_G_L_0_G_D_0_P_0_${uniqueId}`}
              stroke="#1e1e1e"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              strokeWidth="5"
              strokeOpacity="1"
              d=" M-12.87 -0.75 C-12.87,-0.75 -12.75,-0.75 -12.75,-0.75 C-12.75,-0.75 -12.87,-0.75 -12.87,-0.75 "
            />
          </g>
        </g>
      </g>
      <g id={`time_group_${uniqueId}`} />
    </svg>
  )
}
